export default new class Touch {
	init() {
		this.initTouch();
    }

    initTouch() {
		const ua = window.navigator.userAgent;
		const edge = ua.indexOf('Edge');
	
		function hasTouch() {
			return 'ontouchstart' in document.documentElement
				|| navigator.maxTouchPoints > 0
				|| navigator.msMaxTouchPoints > 0;
		}
	
		if (hasTouch()) { // Remove all the :hover stylesheets
			if (edge == -1) {
				try { // Prevent exception on browsers not supporting DOM styleSheets properly
					for (let si in document.styleSheets) {
						const styleSheet = document.styleSheets[si];
						if (!styleSheet.rules) continue;
	
						for (let ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
							if (!styleSheet.rules[ri].selectorText) continue;
	
							if (styleSheet.rules[ri].selectorText.match(':hover')) {
								styleSheet.deleteRule(ri);
							}
						}
					}
				} catch (ex) { console.log(''); }
			}
		}
    }
}